/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { Loading } from "../loading-spinner/Loading";
import "./Placeholder.scss";
import { SvgIModelJs } from "../icons/SvgIModeljs";

// use animation delay with css to initially hide spinner if visibility interval is very short
// this happens when restoring data from cache
// https://stackoverflow.com/questions/30855985/pure-css-animation-visibility-with-delay
export const Placeholder = ({ loading }: { loading?: boolean }) => {
  return (
    <div className="loading-placeholder">
      <div className="placeholder-item placeholder-icon">
        <SvgIModelJs />
      </div>
      {loading && <div className="placeholder-item" data-testid="atp-sandbox-loader">
        <Loading />
      </div>}
    </div>
  )
};
